import React, { useState, useEffect, useRef, useCallback } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import { Autocomplete, Box, TextField, MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import { getPriestEvents } from "../../../Apiservices/Auth/servers/fetchProviderData";  
import { useDispatch, useSelector } from "react-redux";
import { fetchserviceitemssecond } from "../../../Apiservices/Auth/servers/fetchProviderData";
import CateringServiceforuser from "../../../component/newcateringuiforproviderlist/CateringServiceforuser";
import { 
  setCommonData, 
  closeServiceDialog, 
  resetServiceBooking,
  openProviderDialog,
  setEventId,
  setAvailableEvents,
  setTentItems,
  setServiceType,
  showTentItemsSelection,
  showCateringSelection,
  showServiceForm,
  closeDialogForLogin
} from "../../../store/serviceBookingSlice";
import { useNavigate } from "react-router-dom";
import useWindowSize from "../../../util/useWindowSize";
import styles from './ServiceBookingDialog.module.css';
import CustomCalendar from "../Customcalender";
import Tenthouseaccordian from '../../../component/EventServices/Tenthouseaccordian';

const ServiceBookingDialog = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { 
    isDialogOpen, 
    serviceType, 
    commonData, 
    availableEvents,
    activeSelection
  } = useSelector(state => state.serviceBooking);
  
  const [location, setLocation] = useState({ lat: 0, lng: 0 });
  const [address, setAddress] = useState("");
  const [area, setArea] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [eventDate, setEventDate] = useState(null);
  const [eventTime, setEventTime] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [whoseEvent, setWhoseEvent] = useState("");
  const [autocompleteService, setAutocompleteService] = useState(null);
  const [placesService, setPlacesService] = useState(null);
  const [isResumingFromLogin, setIsResumingFromLogin] = useState(false);
  const [locationSuggestions, setLocationSuggestions] = useState([]);
  const [errors, setErrors] = useState({});
  const isLoggedIn = useSelector((state)=>state.auth.isLoggedIn)
  const [tentItemsData, setTentItemsData] = useState([]);
  const [loadingTentItems, setLoadingTentItems] = useState(false);
  
  const { width } = useWindowSize();
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_API_KEY;
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey,
    libraries: ["places", "maps"],
  });

  const mapRef = useRef(null);

  // ✅ SIMPLIFIED: Single useEffect for dialog state management
useEffect(() => {
  

  if (!isDialogOpen) {
    setIsResumingFromLogin(false);
    return;
  }

  // Handle pending data from localStorage (for login redirects)
  const pendingServiceData = localStorage.getItem('pendingServiceData');
  if (pendingServiceData) {
    try {
      const serviceData = JSON.parse(pendingServiceData);
      
      
      localStorage.removeItem('pendingServiceData');
      
      // IMPORTANT: Clear any existing state first
      dispatch(setServiceType(serviceData.serviceType));
      dispatch(setCommonData(serviceData.commonData));
      
      // Force the correct screen based on currentStep
      if (serviceData.currentStep === 'cateringSelection') {
        
        // Force immediate transition to catering selection
        setTimeout(() => {
          dispatch(showCateringSelection());
        }, 0);
        return;
      } else if (serviceData.currentStep === 'providerSelection') {
        
        // Directly open provider dialog and close this one
        dispatch(openProviderDialog());
        dispatch(closeDialogForLogin()); // Use the new action
        return;
      }
    } catch (error) {
      console.error("Error parsing pending data:", error);
    }
  }

  // Only run this logic if there's NO pending data or after pending data is processed
  
  
  // Determine which screen to show based on current state
  const hasBasicData = commonData.address && commonData.eventDate;
  const hasTentItems = commonData.selectedTentItems?.length > 0;
  const hasCateringItems = commonData.cateringSelectedItems?.length > 0;

  

  // If we're already on a specific screen, don't change it
  if (activeSelection === 'tentItems' || activeSelection === 'cateringSelection') {
    
    return;
  }

  // SPECIAL CASE: If we have catering serviceType but are still on serviceForm
  // This happens after login
  if (serviceType === 'catering' && activeSelection === 'serviceForm' && hasBasicData) {
    
    setTimeout(() => {
      dispatch(showCateringSelection());
    }, 0);
    return;
  }

  if (!hasBasicData) {
    // No address/date yet - show service form
    
    dispatch(showServiceForm());
  } else if (serviceType === 'tent' && hasTentItems) {
    // Has tent items to select
    
    dispatch(showTentItemsSelection());
    fetchTentItems();
  } else if (serviceType === 'catering' && hasCateringItems) {
    // Has catering items to select
    
    dispatch(showCateringSelection());
  } else {
    // Has basic data but no specific items - show service form
    
    dispatch(showServiceForm());
  }

  // Fetch events if needed
if (availableEvents.length === 0) {
  getPriestEvents("").then(response => {
    
    
    // Response IS the array of categories
    const categories = response;
    
    if (Array.isArray(categories)) {
      
      
      // Extract events from all categories
      const allEvents = [];
      
      categories.forEach((category, index) => {
        
        
        if (category && category.events && Array.isArray(category.events)) {
          
          
          // Add all events from this category
          category.events.forEach(event => {
            if (event && event.id) {
              allEvents.push(event);
              console.log(`   → Added: ${event.name || 'Unnamed'} (ID: ${event.id})`);
            }
          });
        } else {
          console.log(`   No valid events found in category`);
        }
      });
      
      
      
      // Dispatch to Redux
      dispatch(setAvailableEvents(allEvents));
      
    } else {
      console.error("❌ Response is not an array:", response);
      console.error("Expected: Array of categories");
      console.error("Got:", typeof response);
      dispatch(setAvailableEvents([]));
    }
  }).catch(error => {
    console.error("❌ Error fetching events:", error);
    dispatch(setAvailableEvents([]));
  });
}
}, [isDialogOpen, activeSelection, serviceType, commonData, dispatch]);
  // Google Maps initialization
  useEffect(() => {
    if (isLoaded && window.google) {
      setAutocompleteService(new window.google.maps.places.AutocompleteService());
      setPlacesService(new window.google.maps.places.PlacesService(document.createElement('div')));
    }
  }, [isLoaded]);

  // Initialize form fields from Redux when dialog opens
  useEffect(() => {
    if (isDialogOpen && commonData) {
      setAddress(commonData.address || "");
      setLocation({
        lat: commonData.latitude || 0,
        lng: commonData.longitude || 0
      });
      setArea(commonData.area || "");
      setCity(commonData.city || "");
      setState(commonData.state || "");
      setCountry(commonData.country || "");
      setEventDate(commonData.eventDate ? new Date(commonData.eventDate) : null);
      setEventTime(commonData.eventTime ? new Date(commonData.eventTime) : null);
      setSelectedEvent(commonData.eventId || "");
      setWhoseEvent(commonData.whoseEvent || "");
    }
  }, [isDialogOpen, commonData]);

  // ✅ SIMPLIFIED: Tent items fetch
  const fetchTentItems = useCallback(async () => {
    setLoadingTentItems(true);
    try {
      const itemsdata = await fetchserviceitemssecond();
      setTentItemsData(itemsdata.data);
    } catch (error) {
      console.error("Error fetching tent items:", error);
      setTentItemsData([]);
    } finally {
      setLoadingTentItems(false);
    }
  }, []);

  // ✅ SIMPLIFIED: Form submission
 const handleNext = useCallback(async () => {
  if (!validateForm()) return;

  const commonDataPayload = {
    location: address,
    address,
    latitude: location.lat,
    longitude: location.lng,
    area,
    city,
    state,
    country,
    eventDate: eventDate ? eventDate.toISOString() : null,
    eventTime: eventTime ? eventTime.toISOString() : null,
    eventType: availableEvents.find(event => event.id === selectedEvent)?.name || '',
    whoseEvent,
    eventId: selectedEvent,
    eventName: availableEvents.find(event => event.id === selectedEvent)?.name || ''
  };

  dispatch(setCommonData(commonDataPayload));

  // Handle service type routing
  if (serviceType === 'priest') {
    

    if(!isLoggedIn)
      {
        dispatch(closeDialogForLogin());
        navigate('/login')
        dispatch(openProviderDialog());
      }
    else{
        dispatch(closeDialogForLogin());        
        dispatch(openProviderDialog());
        console.log("going to login")
    }  
  } else if (serviceType === 'tent') {
      if(!isLoggedIn){
        navigate('/login')
        dispatch(showTentItemsSelection());
        await fetchTentItems();
      }
      else{
             dispatch(showTentItemsSelection());
        await fetchTentItems();
      }
  } else if (serviceType === 'catering') {
   
  
    
    if (isLoggedIn) {
      
      // Clear any previous catering selection state
      dispatch(setCommonData({
        ...commonDataPayload,
        cateringSelectedItems: [], // Reset catering items
        cateringQuantity: 1
      }));
      dispatch(showCateringSelection());
    } else {
      
      const pendingServiceData = {
        commonData: commonDataPayload,
        serviceType: 'catering',
        currentStep: 'cateringSelection'
      };
      localStorage.setItem('pendingServiceData', JSON.stringify(pendingServiceData));
       dispatch(closeDialogForLogin());
      navigate('/login');
      localStorage.setItem('showEventTabsAfterLogin', 'true');
      // dispatch(openProviderDialog());
    }
  }
}, [address, location, area, city, state, country, eventDate, eventTime, selectedEvent, whoseEvent, serviceType, dispatch, fetchTentItems, navigate]);
  // ✅ SIMPLIFIED: Form validation
  const validateForm = useCallback(() => {
    const newErrors = {};
    if (!address) newErrors.address = "Event location is required.";
    if (!eventDate) newErrors.eventDate = "Event date is required.";
    if (!whoseEvent) newErrors.whoseEvent = "Please specify whose event it is.";
    if (serviceType === 'priest' && !selectedEvent) {
      newErrors.selectedEvent = "Event type is required for priest booking.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [address, eventDate, whoseEvent, selectedEvent, serviceType]);

  // ✅ SIMPLIFIED: Handlers
  const handleTentItemsNext = useCallback((selectedItems) => {
    dispatch(setTentItems(selectedItems));
    const serviceIds = selectedItems.map(item => item.id);
    dispatch(setCommonData({
      ...commonData,
      tentServiceIds: serviceIds,
      selectedTentItems: selectedItems
    }));
    if(!isLoggedIn){
      dispatch(openProviderDialog());
      navigate('/login')
    dispatch(closeDialogForLogin());
  } else{
      dispatch(openProviderDialog());
    dispatch(closeDialogForLogin());
  }

  }, [commonData, dispatch]);

  const handleCateringNextforuser = useCallback((cateringData, quantity) => {
  const updatedCommonData = {
    ...commonData,
    cateringData: cateringData,    
    cateringQuantity: quantity,
  };
  dispatch(setCommonData(updatedCommonData));
  
  if (isLoggedIn) {
    
    // User is logged in - go directly to provider dialog
    dispatch(openProviderDialog());
    dispatch(closeDialogForLogin());
  } else {
    
    // User is not logged in - save state and redirect to login
    const pendingServiceData = {
      commonData: updatedCommonData,
      serviceType: 'catering',
      currentStep: 'providerSelection'
    };
    localStorage.setItem('pendingServiceData', JSON.stringify(pendingServiceData));
    
    dispatch(closeDialogForLogin());
    navigate('/login');
  }
}, [commonData, dispatch, navigate]);

  const handleClose = useCallback(() => {
  // Reset all local state
  setLocation({ lat: 0, lng: 0 });
  setAddress("");
  setArea("");
  setCity("");
  setState("");
  setCountry("");
  setEventDate(null);
  setEventTime(null);
  setSelectedEvent("");
  setWhoseEvent(""); 
  setLocationSuggestions([]);
  setErrors({});
  setTentItemsData([]);
  setLoadingTentItems(false);
  
  // Close the dialog
  dispatch(closeServiceDialog());
  dispatch(resetServiceBooking())
}, [dispatch]);

  const handleBackToServiceForm = useCallback(() => {
    dispatch(showServiceForm());
  }, [dispatch]);

  const handleEventChange = useCallback((event) => {
    const eventId = event.target.value;
    setSelectedEvent(eventId);
    const selectedEventData = availableEvents.find(event => event.id === eventId);
    if (selectedEventData) {
      dispatch(setEventId({
        id: selectedEventData.id,
        name: selectedEventData.name
      }));
    }
  }, [availableEvents, dispatch]);

  // ✅ SIMPLIFIED: Google Maps functions
  const fetchAddress = useCallback((lat, lng) => {
    if (!isLoaded) return;
    
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        const result = results[0];
        const addressComponents = result.address_components;
        const getComponent = (type) =>
          addressComponents.find((comp) => comp.types.includes(type))?.long_name || "";

        setAddress(result.formatted_address);
        setArea(getComponent("sublocality") || getComponent("locality"));
        setCity(getComponent("locality"));
        setState(getComponent("administrative_area_level_1"));
        setCountry(getComponent("country"));
      }
    });
  }, [isLoaded]);

  useEffect(() => {
    if (!location.lat || !location.lng) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            setLocation({ lat: latitude, lng: longitude });
            fetchAddress(latitude, longitude);
          },
          (error) => console.error("Error fetching location:", error)
        );
      }
    } else {
      fetchAddress(location.lat, location.lng);
    }
  }, [location.lat, location.lng, fetchAddress]);

  const handleMapClick = useCallback((e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    setLocation({ lat, lng });
    fetchAddress(lat, lng);
  }, [fetchAddress]);

  const handleMarkerDragEnd = useCallback((e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    setLocation({ lat, lng });
    fetchAddress(lat, lng);
  }, [fetchAddress]);

  const useCurrentLocation = useCallback(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ lat: latitude, lng: longitude });
          fetchAddress(latitude, longitude);
        },
        (error) => {
          console.error("Error fetching location:", error);
          alert("Unable to fetch location. Please enable location services.");
        }
      );
    }
  }, [fetchAddress]);

  const handleLocationInputChange = useCallback((event, value) => {
    setAddress(value);
    if (value.length > 2 && autocompleteService) {
      autocompleteService.getPlacePredictions(
        {
          input: value,
          types: ['establishment', 'geocode'],
          componentRestrictions: { country: 'in' }
        },
        (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
            setLocationSuggestions(predictions.map(prediction => ({
              description: prediction.description,
              placeId: prediction.place_id
            })));
          } else {
            setLocationSuggestions([]);
          }
        }
      );
    } else {
      setLocationSuggestions([]);
    }
  }, [autocompleteService]);

  const handleLocationSelect = useCallback((event, value) => {
    if (value && placesService) {
      const request = {
        placeId: value.placeId,
        fields: ['geometry', 'formatted_address', 'name', 'address_components']
      };

      placesService.getDetails(request, (place, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();
          
          setLocation({ lat, lng });
          setAddress(place.formatted_address || value.description);
          
          if (place.address_components) {
            const getComponent = (type) =>
              place.address_components.find((comp) => comp.types.includes(type))?.long_name || "";

            setArea(getComponent("sublocality") || getComponent("locality"));
            setCity(getComponent("locality"));
            setState(getComponent("administrative_area_level_1"));
            setCountry(getComponent("country"));
          }

          if (mapRef.current) {
            mapRef.current.panTo({ lat, lng });
            mapRef.current.setZoom(15);
          }
        }
      });
    }
    setLocationSuggestions([]);
  }, [placesService]);

  // ✅ SIMPLIFIED: Header logic
  const getDialogHeader = useCallback(() => {
    if (activeSelection === 'tentItems') {
      return 'Select Tent Items - Step 1 of 2';
    }
    if (activeSelection === 'cateringSelection') {
      return 'Select Catering Options - Step 1 of 2';
    }
    
    switch (serviceType) {
      case 'catering': return 'Order Catering Service - Step 1 of 2';
      case 'priest': return 'Book a Priest';
      case 'tent': return 'Rent from Tent House - Step 1 of 2';
      default: return 'Book Service';
    }
  }, [activeSelection, serviceType]);

  // ✅ SIMPLIFIED: Render functions
  const renderTentItemsSelection = useCallback(() => (
    loadingTentItems ? (
      <div className={styles.loadingContainer}>
        <div className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></div>
        <p>Loading tent items...</p>
      </div>
    ) : (
      <div className={styles.quickservice_tentitemsshowcontainer}>
        <Tenthouseaccordian
          serviceData={tentItemsData}
          onNext={handleTentItemsNext}
          onClose={handleBackToServiceForm}
        />
      </div>
    )
  ), [loadingTentItems, tentItemsData, handleTentItemsNext, handleBackToServiceForm]);

  const renderCateringSelection = useCallback(() => (
    <div className={styles.quickservice_cateringshowcontainer}>
      <CateringServiceforuser
        onNext={handleCateringNextforuser}
        onClose={handleBackToServiceForm}
        isResuming={true} 
      />
    </div>
  ), [handleCateringNextforuser, handleBackToServiceForm]);

  const renderServiceForm = useCallback(() => (
    <div className={styles.eventFormInner}>
      <div className={styles.eventFormBody}>
        <Box className={styles.mapContainer}>
          {isLoaded ? (
            <GoogleMap
              mapContainerStyle={{
                height: width > 768 ? "30vh" : "40vh",
                width: "100%",    
              }}
              center={location}
              zoom={15}
              onClick={handleMapClick}
              onLoad={(map) => (mapRef.current = map)}
            >
              <MarkerF
                position={location}
                draggable
                onDragEnd={handleMarkerDragEnd}
              />
            </GoogleMap>
          ) : (
            <div className={styles.loadingContainer}>Loading Map...</div>
          )}
          <Button
            size="small"
            label="Use Current Location"
            onClick={useCurrentLocation}
            className={styles.currentLocationButton}
          />
        </Box>

        <Box className={styles.formContainer}>
          <TextField
            name="whoseEvent"
            label="Whose Event is it?"
            value={whoseEvent}
            onChange={(e) => setWhoseEvent(e.target.value)}
            size="small"
            variant="outlined"
            fullWidth
            error={Boolean(errors.whoseEvent)}
            helperText={errors.whoseEvent || ""}
            className={`${styles.formField} ${errors.whoseEvent ? styles.errorField : ''}`}
          />

          {serviceType === 'priest' && (
            <FormControl fullWidth size="small" className={styles.formField}>
              <InputLabel>Select Event Type</InputLabel>
              <Select
                value={selectedEvent}
                onChange={handleEventChange}
                label="Select Event Type"
                error={Boolean(errors.selectedEvent)}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 48 * 4.5,
                      overflowY: 'auto',
                    },
                  },
                }}
              >
                {availableEvents.map((event) => (
                  <MenuItem key={event.id} value={event.id}>
                    {event.name}
                  </MenuItem>
                ))}
              </Select>
              {errors.selectedEvent && (
                <div className={styles.errorText}>{errors.selectedEvent}</div>
              )}
            </FormControl>
          )}

          <Autocomplete
            freeSolo
            options={locationSuggestions}
            getOptionLabel={(option) => 
              typeof option === 'string' ? option : option.description
            }
            onInputChange={handleLocationInputChange}
            onChange={handleLocationSelect}
            value={address}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Event Location/Venue"
                size="small"
                fullWidth
                error={Boolean(errors.address)}
                helperText={errors.address || ""}
                className={`${styles.formField} ${errors.address ? styles.errorField : ''}`}
              />
            )}
            renderOption={(props, option) => (
              <li {...props} key={option.placeId}>
                {option.description}
              </li>
            )}
          />

          <CustomCalendar
            value={eventDate}
            onChange={(e) => setEventDate(e.value)}
            placeholder="Event Date & Time"
            showTime={true}
            minDate={new Date()}
            showIcon={true}
            inputStyle={{
              width: '100%',
              padding: '8px 12px',
              border: errors.eventDate ? '1px solid #f44336' : '1px solid #ccc',
              borderRadius: '4px',
              cursor: 'pointer',
              backgroundColor: '#fff'
            }}
          />
          {errors.eventDate && (
            <div className={styles.errorText}>{errors.eventDate}</div>
          )}

          <div className={styles.buttonGroup}>
            <Button
              size="small"
              type="button"
              className={styles.submitButton}
              label="Next"
              onClick={handleNext}
            />
            <Button
              size="small"
              className={styles.cancelButton}
              label="Cancel"
              onClick={handleClose}
            />
          </div>
        </Box>
      </div>
    </div>
  ), [isLoaded, width, location, handleMapClick, handleMarkerDragEnd, useCurrentLocation, whoseEvent, errors, serviceType, selectedEvent, handleEventChange, availableEvents, locationSuggestions, handleLocationInputChange, handleLocationSelect, address, eventDate, handleNext, handleClose]);

  // ✅ SIMPLIFIED: Main render
  // console.log("🔍 Current state:", { activeSelection, serviceType, isDialogOpen });

  return (
    <Dialog
      header={getDialogHeader()}
      visible={isDialogOpen}
      onHide={handleClose}
      closable={true}
      breakpoints={{ "960px": "75vw", "640px": "100vw" }}
      className={styles.dialogContainer}
    >
      {activeSelection === 'tentItems' ? renderTentItemsSelection() : 
       activeSelection === 'cateringSelection' ? renderCateringSelection() : 
       renderServiceForm()}
    </Dialog>
  );
};

export default React.memo(ServiceBookingDialog);